exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  display: block;\n  background-color: #F1F0F0;\n  overflow-y: auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/ui-base/components/mainarea/mainarea.component.scss
// module id = ../../../../../src/app/modules/ui-base/components/mainarea/mainarea.component.scss
// module chunks = main